module.exports = __webpack_public_path__ + "static/media/covid.4e2db052.png";